import { WithChildren } from '@k3/core'
import { Utility } from '../utility/Utility'

export const Layout: React.FC<WithChildren> = ({ children }): JSX.Element => {
  return (
    <>
      <Utility orbitControls axesHelper={false} />
      {children}
    </>
  )
}
